import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { assignRole } from "../../../core/data/redux/employeesSlice";
import { fetchAll } from "../../../core/data/redux/rolePermissionsSlice";
import { useDispatch, useSelector } from "react-redux";


interface RoleProps {
    employee: any
}

const Roles = (props: RoleProps) => {

    const { employee } = props;
    const dispatch = useDispatch();
    const roleState = useSelector((state: any) => state.roleState);
    const [dataList, setDataList] = React.useState<any[]>([]);
    const [selectedRole, setSelectedRole] = React.useState<any | null>(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10
    });


    React.useEffect(() => {
        setSelectedRole(employee?.hrms_role?.role_id)
    }, [employee]);

    const fetchRecords = (pagination: any) => {
        dispatch(fetchAll({ page: pagination.current, limit: pagination.pageSize }));
    }

    React.useEffect(() => {
        fetchRecords(pagination);
    }, []);

    const handleSelect = (id: any) => {
        setSelectedRole(id);
    }

    const handleAssign = async () => {
        const payload = {
            empId: employee.empId,
            role_id: selectedRole
        };
        await dispatch(assignRole(payload));
    }


    React.useEffect(() => {
        if (roleState.loading === "fulfilled" && roleState.action === "list") {
            const result = roleState?.data?.data || null;
            if (result.data && result.data.length > 0) {
                const roles = result?.data || [];
                setDataList(roles);
                setPagination({
                    ...pagination,
                    total: result.total || roles.length,
                    current: result.page || 1,
                    pageSize: result.limit || 10
                });
            } else {
                setDataList([]);
            }
        }
    }, [roleState.loading]);


    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            width: 100,
            render: (text: string, record: any, index: number) => (
                <>
                    <div style={{ display: 'flex' }}>
                        <div>
                            {(pagination.current) ? (index + pagination.current * pagination.pageSize - pagination.pageSize + 1) : (index + 1)}
                        </div>
                        <div style={{ marginLeft: 10 }}>
                            {(selectedRole && selectedRole === record.id) ? <input checked={true} type="radio" name="assign" onChange={() => handleSelect(record.id)}></input>
                                : <input checked={false} type="radio" name="assign" onChange={() => handleSelect(record.id)}></input>
                            }
                        </div>
                    </div>
                </>
            ),
            sorter: (a: any, b: any) => a.id.length - b.id.length,
        },
        {
            title: "Role Name",
            dataIndex: "role_name",
            sorter: (a: any, b: any) =>
                a.role_name.length - b.role_name.length,
        },
    ];


    const handlePagination = (pagination: any) => {
        setPagination({
            current: pagination.page,
            pageSize: pagination.pageSize,
            total: pagination.total || 10
        });
        fetchRecords(pagination);
    };





    return (<div>
        <>
            <div className="pt-2">
                <Table
                    columns={columns}
                    dataSource={dataList}
                    Selection={false}
                    paginationConfig={pagination}
                    handlePagination={handlePagination}
                    loading={roleState.loading === "pending"}
                    scroll={{ y: 300 }}
                />
            </div>
            <div className="row align-items-center">
                <div className="col-md-12">
                    <div className="datatable-paginate mt-4" />
                    <div className="d-flex justify-content-center pb-3 pt-0">
                        {selectedRole ?
                            <Link to="#" data-bs-dismiss="modal" className="btn btn-primary" onClick={() => handleAssign()}>
                                Assign
                            </Link>

                            : <Link to="#" data-bs-dismiss="modal" className="btn btn-primary">
                                Select to assign
                            </Link>
                        }
                    </div>
                </div>
            </div>
        </>
    </div>
    );
}

export default Roles; 